import React, { useEffect, useRef, useState } from 'react';
import './Experience.css';

const experienceData = [
  {
    id: 1,
    date: 'Feb 2022',
    title: 'Started Software Engineering Degree',
    company: null,
    description: 'Began a deep dive into the mechanics of software at Curtin University, moving beyond "coding" into the world of algorithms, multithreading, and distributed systems.'
  },
  {
    id: 2,
    date: 'Feb 2024 - Oct 2024',
    title: 'Software Development Intern',
    company: 'Mechanical Rock',
    description: 'Thrown into the deep end of Agile consulting, building serverless AWS architectures and CI/CD dashboards for real-world production environments.'
  },
  {
    id: 3,
    date: 'March 2025',
    title: 'Graduated',
    company: null,
    description: 'Completed my Software Engineering major with a portfolio ranging from Java-based concurrency simulations to full-stack MERN applications.'
  },
  {
    id: 4,
    date: 'July 2025',
    title: 'Associate Software Test Engineer',
    company: 'Acquire Technology Solutions',
    description: 'Currently strengthening the core of enterprise products by refactoring automation frameworks and driving a 98% reduction in system test failures.'
  }
];

const TimelineItem = ({ item, index }) => {
  const [isVisible, setIsVisible] = useState(false);
  const itemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      {
        threshold: 0.2
      }
    );

    const currentRef = itemRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div 
      ref={itemRef}
      className={`timeline__item ${isVisible ? 'timeline__item--visible' : ''}`}
      style={{ animationDelay: `${index * 0.2}s` }}
    >
      <div className="timeline__dot"></div>
      <div className="timeline__content">
        <span className="timeline__date">{item.date}</span>
        <h3 className="timeline__title">{item.title}</h3>
        {item.company && <p className="timeline__company">{item.company}</p>}
        {item.description && <p className="timeline__description">{item.description}</p>}
      </div>
    </div>
  );
};

const Experience = () => {
  return (
    <section id="experience" className="experience">
      <div className="experience__container">
        <h2 className="experience__heading">Experience</h2>
        <div className="timeline">
          <div className="timeline__line"></div>
          {experienceData.map((item, index) => (
            <TimelineItem key={item.id} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
